module.exports = __webpack_public_path__ + "media/images/lp_mb-bg1-100f383b3afeeef73c55baf68e4540dc.png";